<template>
    <div class="com-partner">
        <div class="com-partner-wrapper container">		
            <div class="com-title">合作伙伴<label>our Partner</label></div>
            <ul class="com-partner__items block">
                <li class="com-partner__item"><img src="@/assets/parner/1.png"></li>
                <li class="com-partner__item"><img src="@/assets/parner/2.png"></li>
                <li class="com-partner__item"><img src="@/assets/parner/3.png"></li>
                <li class="com-partner__item"><img src="@/assets/parner/4.png"></li>
                <li class="com-partner__item"><img src="@/assets/parner/5.png"></li>
                <li class="com-partner__item"><img src="@/assets/parner/6.png"></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'site-partner'
}
</script>

<style lang="less" scoped>
    .com-partner {
        background: url('~@/assets/bk-1.jpg') no-repeat center;
        padding-bottom: .5rem;
        &__items {
            overflow: hidden;
        }
        &__item {
            width: 16.666%;
            float: left;
            text-align: center;
            padding: .12rem;
            box-sizing: border-box;
            img {
                width: 100%;
                border-radius: .05rem;
                box-shadow: 0 0 0.15rem #E3E3E3;
            }
        }
    }
    @media only screen and (max-width: 750px) {
        .com-partner {
            &-wrapper {
                padding: 0 .3rem;
                box-sizing: border-box;
            }
            &__item {
                width: 33.33%;
            }
        }
    }
</style>


